import { toUnicode } from 'punycode/punycode.es6.js'

// This conversion is important, otherwise umlaute in emails will be displayed like this test@xn--adfaf.com
export default email => toUnicode(email)
